import { ChangesDetection } from "@adas/ng-overlay";
import { E_Gender } from "../../../../../enums/gender.enum";
import { I_IdItemResponse, I_PersonResponse } from "../api/person.response";

/**
 * Datos genericos del paciente
 */
export class C_Person extends ChangesDetection {
  /**
   * Primer nombre
   */
  firstName?: string;
  /**
   * Apellidos
   */
  lastName?: string;
  /**
   * Segundo nombre
   */
  secondName?: string;
  /**
   * Fecha de nacimiento
   */
  birthDate?: string;
  /**
   * Genero de paciente recoido con un enum
   */
  gender: E_Gender = E_Gender.UNKNOWN;
  /**
   * Fecha de admisión del paciente
   */
  admTime?: Date;

  ids?: I_IdItemResponse = {};

  language?: string;
  residentOf?: string;
  bornLocation?: string;
  maritalStatus?: string;
  familyData?: string;

  constructor(json?: I_PersonResponse) {
    super();
    this.initialize(json);
  }


  initialize(json?: I_PersonResponse) {
    if (!json) return;
    if (Object.hasOwn(json, 'firstName')) this.firstName = json.firstName;
    if (Object.hasOwn(json, 'lastName')) this.lastName = json.lastName;
    if (Object.hasOwn(json, 'secondName')) this.secondName = json.secondName;
    if (Object.hasOwn(json, 'birthDate')) this.birthDate = json.birthDate;
    if (Object.hasOwn(json, 'gender')) this.gender = json.gender ?? E_Gender.UNKNOWN;
    if (Object.hasOwn(json, 'admTime')) this.admTime = json.admTime ? new Date(json.admTime) : undefined;
    if (Object.hasOwn(json, 'language')) this.language = json.language;
    if (Object.hasOwn(json, 'residentOf')) this.residentOf = json.residentOf;
    if (Object.hasOwn(json, 'bornLocation')) this.bornLocation = json.bornLocation;
    if (Object.hasOwn(json, 'maritalStatus')) this.maritalStatus = json.maritalStatus;
    if (Object.hasOwn(json, 'familyData')) this.familyData = json.familyData;
    this.forceUpdateDetection();
  }

  clone() {
    const clone = new C_Person();
    clone.firstName = this.firstName;
    clone.firstName = this.firstName;
    clone.lastName = this.lastName;
    clone.secondName = this.secondName;
    clone.birthDate = this.birthDate;
    clone.gender = this.gender;
    clone.admTime = this.admTime;
    clone.language = this.language;
    clone.residentOf = this.residentOf;
    clone.bornLocation = this.bornLocation;
    clone.maritalStatus = this.maritalStatus;
    clone.familyData = this.familyData;
    return clone;
  }

  toInterface(): I_PersonResponse {
    const req: I_PersonResponse = {};
    if (this.firstName) req.firstName = this.firstName;
    if (this.lastName) req.lastName = this.lastName;
    if (this.secondName) req.secondName = this.secondName;
    if (this.birthDate) req.birthDate = this.birthDate;
    if (this.gender) req.gender = this.gender;
    if (this.admTime) req.admTime = this.admTime.toISOString();
    if (this.language) req.language = this.language;
    if (this.ids) req.ids = this.ids;
    if (this.language) req.language = this.language;
    return req;
  }

}
